import { envUrl } from '../../env-url'
import { isSecureLink } from '@/utils'

export default {
  "styles": [
    "/themes/link/css/link.css",
    "https://use.typekit.net/ebk2fpx.css",
    "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap",
    "/common/primary/icons-primary.css"
  ],
  gtm: 'GTM-MDGLJ3X',
  "levels": [
    {
      "level": 1,
      "url": `${isSecureLink()}://link1${envUrl()}`
    },
    {
      "level": 2,
      "url": `${isSecureLink()}://link2${envUrl()}`
    },
    {
      "level": 3,
      "url": `${isSecureLink()}://link3${envUrl()}`
    },
    {
      "level": 4,
      "url": `${isSecureLink()}://link4${envUrl()}`
    },
    {
      "level": 5,
      "url": `${isSecureLink()}://link5${envUrl()}`
    },
    {
      "level": 6,
      "url": `${isSecureLink()}://link6${envUrl()}`
    },
    {
      "level": 7,
      "url": `${isSecureLink()}://link7${envUrl()}`
    }
  ],
  "text": {
    "nb": {
      "LOGIN": {
        "TEXT_TOP": "<i>link</i> er vårt nye engelskverk for hele barnetrinnet. Verket legger vekt på aktivitet, tverrfaglighet og interkulturell kompetanse.",
        "TEXT_FOOTER": "Gratis innlogging på lærersidene for sanger, animasjoner og annet ekstra lærerinnhold. Logg inn med FEIDE eller e-portal."
      }
    }
  },
  "beta": "https://app.bwz.se/vigmostad/b/v?survey=102&ucrc=0E630B5C37",
  "meta": [
    {
      name: "google-site-verification",
      content: "2ujiEqtGXMQEjZUOZWgzdpUYIna7My2QtKMM0GG-9yY"
    }
  ],
  "layout": {
    "nav": "NavPrimary",
    "overview": "OverviewPrimary",
    "unit": "UnitPrimary",
    "lesson": "LessonPrimary",
    "exercise": "ExerciseV1"
  },
  "dbokLink": 'https://app.bwz.se/vigmostad/b/v?survey=269&ucrc=544D3E4D95'
}
